import {fun_PostAction, fun_DeleteAction,fun_Download} from "@/api/index";
import {fun_GetKeys} from "@/utils/validate";
import PrintDialog from "../../components/PrintDialog/index.vue";

export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        prjName: null, // 工程名称
        constructionNo: null, // 报建编号
        prjLargeClass: null, // 工程类别
        noteNumber: null, // 立项文号
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "立项批准文号：",
          value: "noteNumber",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "工程类别：",
          value: "prjLargeClass",
          placeholder: "请输入",
          clearable: true,
          queryParams: {
            url: "/dataDictionaryEntries/engineeringCombobox",
            parentId: "0"
          }
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "工程名称",
          slotName: "prjName",
          minWidth: "300",
          fixed: true,
        },
        {
          label: "状态",
          slotName: "state",
          minWidth: "80",
          fixed: true,
        },
        {
          label: "打印",
          slotName: "dy",
          minWidth: "150",
          fixed: true,
        },
        {
          label: "立项批准文号",
          prop: "noteNumber",
          minWidth: "200",
        },
        {
          label: "工程类别",
          slotName: "prjLargeClassName",
          minWidth: "150",
        },
        {
          label: "项目性质",
          prop: "constructionTypeName",
          minWidth: "150",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          minWidth: "300",
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 温馨提示
      tipList: [],
      // 选中的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType"), // 用户类型
      yhlx: null, // 用户类型
    }
  },
  components: {
    PrintDialog
  },
  // 模板编译完成
  mounted() {
    // 获取用户信息
    this.fun_GetUser();
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取用户信息
     * @returns {Promise<void>}
     */
    async fun_GetUser() {
      // 如果用户标识是工作人员或者监管人员
      if ("工作人员" == this.userFlag || "监管人员" == this.userFlag) {
        // 清空表头
        this.btnList = [];
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/supConstruction/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      })
    },
    /**
     * 下拉框change事件
     * @params e 选择的值
     * @author 滕威
     */
    fun_GetSelectVal(e, field, options) {
      options.map(item => {
        if (item.value === e) {
          this.form[field] = item.value;
        }
      });
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/supConstructionDetail",
            // 操作类型
            query: { controllerFlg: "insert" }
          });
          break;
        case "修改":
          // 执行修改的方法
          this.fun_Edit();
          break;
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
      }
    },
    /**
     * 编辑的方法
     */
    fun_Edit() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 遍历
          this.multipleSelection.forEach(e => {
            // 核验状态为已提交
            if (e.state === "tj") {
              // 错误消息提示
              this.$alert("该项目信息已提交，无法进行删除或修改操作！","warning");
              return;
              // 核验状态为核验通过
            } else if (e.state === "tg") {
              // 错误消息提示
              this.$alert("该项目信息已通过，无法进行删除或修改操作！","warning");
              return;
            } else {
              // 跳转详情页面
              this.$router.push({
                path: "/supConstructionDetail",
                // 操作类型
                query: { id: this.multipleSelection[0].id, controllerFlg: "update"}
              });
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        }
        // 项目编号不为空时
        if (this.multipleSelection[0].applicationId) {
          // 提示，并清除选中数据
          this.$alert("您选择删除的选项中有工程类非类招标申请核验通过的项目！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return false;
        }
        // 状态为提交
        if (this.multipleSelection[0].state == "tj") {
          // 提示，并清除选中数据
          this.$alert("状态为“提交”的项目不能被删除！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return false;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 发起请求，获取结果集
          fun_PostAction("/supConstruction/delete?key=" + this.multipleSelection[0].id).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 判断请求是否成功
            if (result) {
              // 查询列表
              this.fun_GetList();
              // 提示删除成功
              this.$message.success(msg);
            } else {
              // 请求失败，提示信息
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/supConstructionDetail",
        // 操作类型
        query: { id: e.id, controllerFlg: "detail" }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 下拉框清空方法
     */
    fun_Clear(val){
      // 清空
      this.form[val] = null;
    },
    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.id;
      // ids
      this.$refs.printDialog.data = data.id;
      // 权限编号
      this.$refs.printDialog.operationNum = "";
    },
    /**
     * 打印的方法
     */
    fun_DialogPrint(id, agencyCorpId, tender, agencyRecords, bidder, lock, recordNumber) {
        // 根据',' 切割id
        var ids = id.split(",");
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "supConstructionPrint",
        id: ids[0],
        agency: agencyCorpId,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                  "./static/pdf/web/viewer.html?file=" +
                  encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
  }
}